
<img class="right-oval" src="assets/img/ovals/grey-oval-right.png"/>

<ion-content>

  <ion-menu-toggle class="SCWEB-menu-icon">
    <ion-button color="white">
      <img src="assets/img/shortcut-icon.png" class="SCWEB-menu-img" />
    </ion-button>
  </ion-menu-toggle>

  <!-- <div class="SCWEB-address-container" (click)="openSccToThisPage()">
    <p></p>
    <ion-icon name="arrow-redo-circle-outline"></ion-icon>
  </div> -->

  <div class="page-wrapper">

    <div class="name-img-wrapper">
      <img src="assets/img/shortcut-icon.png" class="img" />
      <div class="name">Product Sales</div>
    </div>

    <div class="middle-info">

      <div class="section-header">Promote your products</div>

      <ion-item class="input-item" lines="none">
        <ion-input [(ngModel)]="productInfo.description" name="description" type="text" required placeholder="Product description" maxlength="90">
        </ion-input>
      </ion-item>

      <ion-item class="input-item" lines="none">
        <ion-input [(ngModel)]="productInfo.url" name="url" type="text" required placeholder="Web link (URL with https://)">
        </ion-input>
      </ion-item>

      <ion-item class="img-uploader" lines="none">
        <div *ngIf="!productInfo.picURL">
          <ion-label (click)="addProductImage()">
            <ion-button>Add product image</ion-button>
            <br>
            <span>Upload a .png or .jpg image file.</span>
            <span>Suggested dimensions: 700px wide × 335px tall.</span>
          </ion-label>
        </div>

        <div *ngIf="productInfo.picURL">
          <ion-img [src]="productInfo.picURL" class="actual-img" (click)="addProductImage()"></ion-img>
        </div>
      </ion-item>

      <!-- <div class="section-header">Text message after appointments (optional)</div>

      <ion-item class="input-item" lines="none">
        <ion-input [(ngModel)]="productInfo.textMessage" name="textMessage" type="text" pattern="^[\x20-\x7F]+$" required placeholder="Write a short message" maxlength="140">
        </ion-input>
      </ion-item> -->

      <p class="disclaimer">These settings will be used to configure an in-app promotion, engaging all customers who book with your Pros. Clients will see this promotion after confirming an appointment.</p>

      <ion-button class="SC-long-button submit-button" color="marine" (click)="submit()" type="submit" block>
        Save Settings
      </ion-button>

      <p class="submit-status" *ngIf="submitStatus">{{submitStatus}}</p>
      <p class="error-status" *ngIf="errorStatus">{{errorStatus}}</p>

    </div>

    <div class="support-footer">
      <span class="support-button" (click)="openPage('https://getshortcut.co/faq')">FAQ</span>
      <span class="support-button" (click)="openPage('https://getshortcut.co/privacy')">Privacy policy</span>
      <span class="support-button" (click)="openPage('https://getshortcut.co/terms')">Terms of service</span>
    </div>
  </div>

</ion-content>